"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.render = exports.default = exports.getToolbarButtons = exports.styles = exports.PLUGIN_TAG_SELECTOR = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _jodit = require("jodit");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var {
  $$,
  attr
} = _jodit.Jodit.modules.Helpers;
var PLUGIN_ID = 'dynamicField';
var PLUGIN_TAG = 'dynamic-field';
var PLUGIN_TAG_SELECTOR = "".concat(PLUGIN_TAG);
exports.PLUGIN_TAG_SELECTOR = PLUGIN_TAG_SELECTOR;
var CLASS_PREFIX = 'dynamic-field';
var PLUGIN_WRAPPER_TAG = 'dynamic-field-wrapper';
var ATTRIBUTE_ID = 'data-id';
var ATTRIBUTE_CAPITALIZE = 'data-capitalize';
var MARKER_OPEN = '{';
var MARKER_CLOSE = '}';
var styles = {
  [PLUGIN_TAG_SELECTOR]: {
    userSelect: 'all',
    display: 'inline-block',
    border: '1px solid #8c8c8c',
    ["&[".concat(ATTRIBUTE_CAPITALIZE, "=\"true\"]")]: {
      textTransform: 'uppercase'
    }
  },
  [".".concat(CLASS_PREFIX, "-toolbar-container")]: {
    position: 'relative',
    marginBlock: '8px',
    paddingTop: 8,
    width: '100%',
    '&:after': {
      content: '""',
      position: 'absolute',
      width: 'calc(100% + 5px + 5px)',
      top: 0,
      left: -5,
      borderTop: '1px solid #D9D9D9'
    }
  }
};
exports.styles = styles;

var getToolbarButtons = function getToolbarButtons() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!options.fields) return [];
  var buttons = [...options.fields.filter(field => !field.isExtra).map(field => "".concat(PLUGIN_ID, "-").concat(field.id))];
  var extraFields = options.fields.filter(field => field.isExtra);

  if (extraFields.length) {
    buttons.push("".concat(PLUGIN_ID, "-extra"));
  }

  return buttons;
};

exports.getToolbarButtons = getToolbarButtons;

var getFieldInsertLabel = (field, fallbackText) => (field === null || field === void 0 ? void 0 : field.label) ? "".concat(MARKER_OPEN).concat(field.label).concat(MARKER_CLOSE) : fallbackText;

var getFieldInsert = (field, capitalize) => "\n  <".concat(PLUGIN_TAG, "\n    ").concat(ATTRIBUTE_ID, "=\"").concat(field.id, "\"\n    ").concat(ATTRIBUTE_CAPITALIZE, "=\"").concat(capitalize ? 'true' : 'false', "\"\n  >").concat(getFieldInsertLabel(field), "</").concat(PLUGIN_TAG, ">\n").trim(); // Known issue: at the moment, the plugins adds controls to Jodit.defaultOptions.controls
// This might become an issue when we have to use two Jodit instances with dynamic fields that
// have same field.id but different field.label - think internationalization usecase.


var useDynamicFields = function useDynamicFields() {
  var {
    fields,
    controlsComponent,
    extraLocale
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var ref = (0, _react.useRef)({
    added: false,
    capitalize: false,
    editor: null
  });
  var [, forceRender] = (0, _react.useReducer)(v => !v, false);
  var [domNode, setDomNode] = (0, _react.useState)(null);

  var toggleCapitalize = () => {
    ref.current.capitalize = !ref.current.capitalize; // Hack: we need a way so that toolbar button executes their `update` function.
    // It seems firing `afterResize` also causes `update` function to be executed.

    ref.current.editor.events.fire('afterResize');
    forceRender();
  }; // Can't useEffect here; plugins have to be added before the editor is created


  if (!ref.current.added) {
    var _fields$filter;

    fields === null || fields === void 0 ? void 0 : fields.filter(field => !field.isExtra).forEach(field => {
      _jodit.Jodit.defaultOptions.controls["".concat(PLUGIN_ID, "-").concat(field.id)] = {
        name: PLUGIN_ID,
        text: field.label,
        update: button => {
          // eslint-disable-next-line no-param-reassign
          button.text.style = ref.current.capitalize ? 'text-transform: uppercase;' : '';
        },
        exec: editor => editor.selection.insertHTML(getFieldInsert(field, ref.current.capitalize))
      };
    });
    var extraFields = (_fields$filter = fields === null || fields === void 0 ? void 0 : fields.filter(field => field.isExtra)) !== null && _fields$filter !== void 0 ? _fields$filter : [];

    if (extraFields.length > 0) {
      _jodit.Jodit.defaultOptions.controls["".concat(PLUGIN_ID, "-extra")] = {
        name: PLUGIN_ID,
        text: extraLocale,
        list: Object.fromEntries(extraFields.map(field => [field.id, field.label])),
        childTemplate: (editor, key, value) => value,
        exec: (editor, _, value) => {
          var {
            args
          } = value.control;
          if (!args) return false;
          var [id, label] = args;
          return editor.selection.insertHTML(getFieldInsert({
            id,
            label
          }, ref.current.capitalize));
        }
      };
    }

    _jodit.Jodit.plugins.add(PLUGIN_ID, function initDynamicFields(editor) {
      ref.current.editor = editor;
      editor.events.on('afterInit', () => {
        // do not add the controller if there are no fields
        if (!(fields === null || fields === void 0 ? void 0 : fields.length)) return;
        var {
          toolbarContainer
        } = editor;
        var div = editor.create.fromHTML("<div class=\"".concat(CLASS_PREFIX, "-toolbar-container\"></div>"));
        var reactContainer = editor.create.fromHTML("<div></div>");
        var buttonContainer = editor.create.fromHTML("<div class=\"jodit-ui-group\"></div>");
        document.querySelectorAll(".jodit-ui-group__".concat(PLUGIN_ID)).forEach(elm => {
          buttonContainer.appendChild(elm);
        });
        div.append(reactContainer, buttonContainer);
        toolbarContainer.append(div);
        setDomNode(reactContainer);
      });

      var wrap = originalElement => {
        var element = originalElement;
        var id = element.getAttribute(ATTRIBUTE_ID);

        if (element.parentNode && element.parentNode.tagName.toLowerCase() === PLUGIN_WRAPPER_TAG.toLowerCase()) {
          element = element.parentNode;
        } else {
          var wrapper = editor.createInside.fromHTML("<".concat(PLUGIN_WRAPPER_TAG, " contenteditable=\"false\" draggable=\"true\" />")); // Copy the style attribute to the wrapper element

          attr(wrapper, 'style', attr(element, 'style'));

          if (element.parentNode) {
            element.parentNode.insertBefore(wrapper, element);
          } // add/update label to the element


          element.innerHTML = element.innerHTML.replace(element.textContent, getFieldInsertLabel(fields === null || fields === void 0 ? void 0 : fields.find(field => field.id === id), element.textContent)); // add the actual element inside

          wrapper.appendChild(element);
          element = wrapper;
        } // When clicking on the element, Chrome highlights the dynamic field text (thanks to user-select: all),
        // but FireFox and Safari don't.
        // In that case, we at least need to move the cursor to the correct position
        // We don't need to check for Browser explicitly, because when it highlights in Chrome and we move the cursor,
        // it doesn't make a difference


        editor.events.off(element, 'mousedown.select touchstart.select').on(element, 'mousedown.select touchstart.select', () => {
          editor.selection.setCursorAfter(element);
        });
      };

      editor.events.on('change afterInit afterSetMode changePlace', // we need to "wrap" the dynamic-field so that we can have some control over "contenteditable" prop
      // we cannot change the dynamic-field's contenteditable prop directly as Jodit then allows the element to not
      // behave as a single "block"
      editor.async.debounce(() => {
        if (!editor.isDestructed && editor.getMode() !== _jodit.Jodit.MODE_SOURCE) {
          $$(PLUGIN_TAG_SELECTOR, editor.editor).forEach(elm => {
            wrap(elm);
          });
        }
      }, editor.defaultTimeout)).on('afterGetValueFromEditor', data => {
        // we need to get of all the wrappers we added earlier, before getting the actual content from editor
        var wrapperRegexp = new RegExp("<".concat(PLUGIN_WRAPPER_TAG, "[^>]+>([^]+?)</").concat(PLUGIN_WRAPPER_TAG, ">"), 'ig');

        if (wrapperRegexp.test(data.value)) {
          // eslint-disable-next-line no-param-reassign
          data.value = data.value.replace(wrapperRegexp, '$1');
        }
      }).on('beforeCommand', command => {
        // Before a command is run (unless it is backspace/delete), enable
        // contenteditable so that styles are applied to the element correctly.
        // Without this, the styles will end before the element and start again
        // after the element.
        if (!['backspacebutton', 'deletebutton'].includes(command)) {
          $$(PLUGIN_TAG_SELECTOR, editor.editor).forEach(el => {
            attr(el.parentElement, 'contenteditable', 'true');
          });
        }

        return true;
      }).on('afterCommand', () => {
        $$(PLUGIN_TAG_SELECTOR, editor.editor).forEach(el => {
          attr(el.parentElement, 'contenteditable', 'false');
        });
        return true;
      });
    });

    ref.current.added = true;
  }

  if (!domNode || !controlsComponent) {
    return null;
  }

  var controlProps = {
    capitalize: ref.current.capitalize,
    toggleCapitalize
  };
  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement(controlsComponent, controlProps), domNode);
};

useDynamicFields.propTypes = {
  fields: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    isExtra: _propTypes.default.bool
  })),
  extraLocale: _propTypes.default.string.isRequired,
  controlsComponent: _propTypes.default.node
};
var _default = useDynamicFields;
exports.default = _default;

var render = (content, dynamicFields) => {
  var parser = new DOMParser();
  var doc = parser.parseFromString(content, 'text/html');
  doc.querySelectorAll(PLUGIN_TAG_SELECTOR).forEach(el => {
    var id = el.getAttribute(ATTRIBUTE_ID);
    var capitalize = el.getAttribute(ATTRIBUTE_CAPITALIZE) === 'true';
    var field = dynamicFields.find(f => f.id === id);

    if (field) {
      var renderValue = field.value; // it is possible that the plugin element contains some more elements inside, e.g. <strong>, <em>, etc.
      // to keep them in place, we need to replace only the "text" with the actual dynamic field value.
      // but in rare case, if we do not find any "text" content inside, we disregard those tags.

      var replacementString = el.textContent;

      if (replacementString.length > 0) {
        // eslint-disable-next-line no-param-reassign
        el.innerHTML = el.innerHTML.replace(replacementString, renderValue);
      } else {
        // eslint-disable-next-line no-param-reassign
        el.innerHTML = renderValue;
      }
    } // we should replace `dynamic-field` tag with `span` to prevent any possible issues with unknown tags


    var newEl = doc.createElement('span');
    newEl.style = el.getAttribute('style');
    newEl.style.textTransform = capitalize ? 'uppercase' : '';
    newEl.innerHTML = el.innerHTML;
    el.parentNode.insertBefore(newEl, el);
    el.remove();
  });
  return doc.body.innerHTML;
};

exports.render = render;